import { useCallback } from 'react';
import { useEditHistoryCoordinator, useResolveEditHistoryFaceIdentity } from '../edit-history-store';
import { HistorySnapshot } from '../card-history-coordinator';

export const useHistoryTransaction = () => {
  const coordinator = useEditHistoryCoordinator();
  const resolveFaceIdentity = useResolveEditHistoryFaceIdentity();

  return useCallback(
    async (
      canvas: fabric.Canvas,
      mutation: (isRecorded: boolean) => void | Promise<void>,
      beforeSnapshot?: HistorySnapshot,
    ): Promise<void> => {
      if (!coordinator || !resolveFaceIdentity) {
        await mutation(false);
        return;
      }
      const faceIdentity = resolveFaceIdentity(canvas);
      if (!faceIdentity) {
        await mutation(false);
        return;
      }

      await coordinator.runTransaction(
        faceIdentity,
        canvas,
        () => mutation(true),
        ...(beforeSnapshot ? [beforeSnapshot] : []),
      );
    },
    [coordinator, resolveFaceIdentity],
  );
};
